import { env } from "src/util/env";

export const cookieKeyToken = `${env()}-token`;
